module.exports = __webpack_public_path__ + "static/media/Pineapple.a2c5e05b.png";